
import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { CloudUpload, Download } from 'lucide-react';
import { Label } from '@/components/ui/label';

interface FarmUploadPanelProps {
  file: File | null;
  isUploading: boolean;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleUpload: () => Promise<void>;
  downloadTemplate: () => void;
}

const FarmUploadPanel: React.FC<FarmUploadPanelProps> = ({
  file,
  isUploading,
  handleFileChange,
  handleUpload,
  downloadTemplate
}) => {
  return (
    <div className="space-y-4">
      <div className="bg-blue-50 border border-blue-100 rounded-lg p-4 mb-4">
        <h3 className="text-sm font-medium text-blue-800 mb-2">Excel File Format</h3>
        <p className="text-sm text-blue-700">
          Upload an Excel file with farm data. The file should include columns for Region, Farm Size, 
          Farmer Name, Phone Number, Product Name, and optionally Estimated Harvest (kg).
        </p>
        <Button 
          variant="outline" 
          size="sm" 
          onClick={downloadTemplate} 
          className="mt-2 text-blue-600 border-blue-200 hover:bg-blue-100"
        >
          <Download className="h-4 w-4 mr-2" />
          Download Template
        </Button>
      </div>

      <div className="space-y-2">
        <Label htmlFor="farm-excel-upload">Upload Farm Excel File</Label>
        <div className="flex gap-2">
          <Input
            id="farm-excel-upload"
            type="file"
            accept=".xlsx,.xls"
            onChange={handleFileChange}
            disabled={isUploading}
          />
          <Button 
            onClick={handleUpload} 
            disabled={!file || isUploading}
            className="whitespace-nowrap"
          >
            <CloudUpload className="h-4 w-4 mr-2" />
            {isUploading ? 'Uploading...' : 'Upload'}
          </Button>
        </div>
        {file && (
          <p className="text-sm text-muted-foreground">Selected file: {file.name}</p>
        )}
      </div>
    </div>
  );
};

export default FarmUploadPanel;
